import React, { FC } from 'react';

const Shimmer: FC<{ data: { w: number | string, h: number | string } }> = ({ data: { w, h } }) => {
   const width = typeof w === 'number' ? `${w}px` : w;
   const height = typeof h === 'number' ? `${h}px` : h;

   return <span style={{ width, height }} className='shimmer inline-block'></span>;
};

export default Shimmer;